import { render, staticRenderFns } from "./Ribbon_SettingsWindow.vue?vue&type=template&id=2f1566d2&scoped=true"
import script from "./Ribbon_SettingsWindow.vue?vue&type=script&lang=js"
export * from "./Ribbon_SettingsWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1566d2",
  null
  
)

export default component.exports